import styled from 'styled-components';
import { Link } from '@lessonnine/design-system.lib';

export const InterpolatedLink = styled(Link)`
  position: relative;
  top: -2.5px;
`;
